module.exports = __webpack_public_path__ + "img/hr-decider-combinator-shadow.e714e628.png";